import { attr, fk, oneToOne } from 'redux-orm';
import Model from '../base-model';
import { replyActions } from './reply.action';
import replyReducers from './reply.reducer';

/**
 * Post
 * @typedef {Object} Post
 * @property {string} id
 * @property {string} user
 * @property {string} content
 * @property {Date} sendDate
 * @property {boolean} isLiked
 * @property {number} likes
 */

export class Post extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case replyActions.addPost:
            replyReducers.addPost(session, action.reply, action.discussionId);
            break;
        case replyActions.removePost:
            replyReducers.removePost(session, action.id);
            break;
        case replyActions.likePost:
            replyReducers.likePost(session, action.id, action.isLiked);            
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Post: ${this.id}`
    }
}

Post.modelName = 'Post';

Post.fields = {
    id: attr(),
    user: fk('ForumUser'),
    content: attr(),
    sendDate: attr(),
    isLiked: attr(),
    likes: attr(),
    reply: oneToOne('Reply'),
}

export class Reply extends Model {

    toString() {
        return `Reply: ${this.id}`
    }
}

Reply.modelName = 'Reply';

Reply.fields = {
    userName: attr(),
    userRole: attr(),
    content: attr(),
    postId: attr(),
}